import { Box, Button } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import { useState } from "react";

type Props = {
  selectRange: (startTimestamp: number, endTimestamp: number) => void;
  onClose: () => void;
};

function DatePickerComponent({ selectRange, onClose }: Props) {
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);

  const handleApply = () => {
    if (startDate && endDate) {
      const start = startDate.startOf("day").valueOf();
      const end = endDate.endOf("day").valueOf();
      selectRange(start, end);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" flexDirection="column" gap={2} alignItems="center">
        <Box display="flex" gap={2}>
          <DatePicker
            label="Start Date"
            value={startDate}
            disableFuture
            onChange={(newVal) => setStartDate(newVal)}
          />
          <DatePicker
            label="End Date"
            value={endDate}
            minDate={startDate ?? undefined}
            disableFuture
            onChange={(newVal) => setEndDate(newVal)}
          />
        </Box>
        <Box display="flex" gap={2} mt={2}>
          <Button variant="contained" disabled={!startDate || !endDate} onClick={handleApply}>
            Apply
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </LocalizationProvider>
  );
}

export {DatePickerComponent};
